export default __webpack_public_path__ + "static/media/catsgetangry.b522c438.png";